import {BaseService, Body, Field, GET, Headers, Path, POST, Query, Response} from 'ts-retrofit';
import {ACCEPT_JSON} from '../config';
import {User} from "../../../models/user";
import {UserData} from '../../../models/user-data';
import {ToData} from '../rest-api-hydratator-decorators';

const base = 'auth';

export class AuthenticationApiService extends BaseService {

  @POST(`/${base}/login`)
  @Headers({
    ...ACCEPT_JSON
  })
  async login(
    @Field('username') username: string,
    @Field('password') password: string,
  ) {
    return <Response<UserData>>{};
  }

  @POST(`/${base}/twoFactor`)
  @Headers({
    ...ACCEPT_JSON
  })
  async loginTwoFactor(@Body code: { data: string }) {
    return <Response<UserData>>{};
  }

  @GET(`/${base}/apitoken`)
  @Headers({
    ...ACCEPT_JSON
  })
  async getBotToken(): Promise<Response<string>> {
    return <Response>{};
  }

  @GET(`/${base}/user`)
  @Headers({
    ...ACCEPT_JSON
  })
  async refreshToken(): Promise<Response<UserData>> {
    return <Response>{};
  }

}
